var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/small 12px Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module/overall-",
    transform: "translate(-20.000000, -57.000000)",
    stroke: "#111111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Insights/Followers",
    transform: "translate(20.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiple",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.5,
    cy: 3.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.5,
    cy: 3.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,8.5 L5.5,8.5 C2.73857625,8.5 0.5,10.7385763 0.5,13.5 L10.5,13.5 C10.5,10.7385763 8.26142375,8.5 5.5,8.5 L5.5,8.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.841,7.99999596 C11.3324254,7.67302327 11.9097358,7.49902978 12.5,7.49999596 L12.5,7.49999596 C14.1568542,7.49999596 15.5,8.84314575 15.5,10.499996 L15.5,11.499996 L12.5,11.499996",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.93ca8906cfff676e6336988ef955176f.svg";
export { ForwardRef as ReactComponent };